import {combineReducers} from "redux";

import userReducer from "./auth/user.reducer";

const rootReducer = combineReducers({user: userReducer});

export default rootReducer;
